import Vue from 'vue';
import Vuex from 'vuex';

import * as types from '@/store/mutation-types';

import projectService from '@/services/projects.js';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: undefined,
    project: undefined,
    showLogicalLangage: false,
  },
  mutations: {
    [types.LOAD_COGNITO_USER] (state, user) {
      state.user = user;
    },
    [types.LOGOUT_COGNITO_USER] (state) {
      state.user = undefined;
    },
    [types.LOAD_PROJECT] (state, project) {
      state.project = project;
    },
    [types.UNLOAD_PROJECT] (state) {
      state.project = undefined;
    },
    [types.UPDATE_SHOW_LOGICAL_LANGAGE] (state, value) {
      state.showLogicalLangage = value;
    }
  },
  actions: {
    loadCognitoUser({ commit }, user) {
      commit(types.LOAD_COGNITO_USER, user);
    },
    logoutCognitoUser({ commit }) {
      commit(types.LOGOUT_COGNITO_USER);
    },

    loadProject({ commit }, projectId) {
      return new Promise((resolve, reject) => {
        projectService.getProject(projectId).then(res => {
          commit(types.LOAD_PROJECT, res.data);
          resolve(res.data);
        }).catch(err => {
          reject(err);
        });
      });
    },
    unloadProject({ commit }) {
      commit(types.UNLOAD_PROJECT);
    },

    updateShowLogicalLangage({ commit }, value) {
      commit(types.UPDATE_SHOW_LOGICAL_LANGAGE, value);
    },
  },
  modules: {
  },
});
